import { SparklineContainer, StyledIcon, StyledPlusIconDiv, WidgetEdit, WidgetOverlay, WidgetWrapStyle } from "./styles";
import { getIcon, setpathParam, trendIconSelect } from "../../global/utility/statisticsUtil";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Box, Stack, Tooltip } from "@mui/material";
import { SparkLineChart } from "@mui/x-charts";
import { ReactComponent as LocationAlt } from "../../assets/location-alt.svg";
import { Icon } from "@vds/icons";
import { useState, useEffect } from "react";
import { getWidgetStatistics } from "../../api/EbcWidgetStatisticManager";
import { useSelector } from "react-redux";
import {isEmpty} from "lodash";
import useInterval from "../../global/hooks/useIntervalHooks";
import { convertToTime, convertToTimeWithValues, convertToTimeWithNetValues, formatTimerValue } from "../../global/utility/Utils";
import { getLocationHierarchy } from "../../global/utility/widgetUtils";
import { Body } from "@vds/typography";
import { getcvAppDisplayName, getcvAppName,getcvAppDispName } from "../../global/utility/cvAppUtils";
import { getDeviceVirtualIdFromTagId } from "../../global/utility/statisticsUtil";
import "./StatWidget.css";
import { Spinner } from "react-bootstrap";
import { ROI_LIST_WITH_CVAPPS_LOADING_STATUS } from "../../store/actions";
const StatWidget = ({editMode, onDragStart, content, id, clearClicked}) => {
  const cVappList = useSelector((state) => state.cvAppReducer.cvAppList);
  const navigate = useNavigate();
  const roiListWithCvappsLoadingStatus = useSelector((state) => state.polygonRoiReducer.roiListWithCvappsLoadingStatus);
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const selectedTimerData = useSelector((state) => state.widgetReducer.selectedTimerValue);
  const WidgetListFrmStatReducer = useSelector((state) => state.statisticsReducer.widgets);
  const locationDeviceMapping = useSelector((state) => state.deviceReducer.locationDeviceMapping);
  const [data, setData] = useState({
    netValue: 0,
    value: 0,
    sparklineData: []
  });
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const roiList = useSelector((state) => state.polygonRoiReducer.roiListWithCvapps);
  const locationHierarcy = getLocationHierarchy(sitesTagList, content.location);
  const INTERVAL_TIMER = 1000 * 15; // 15000 ms or 15s
  const DWELLTIME_APP = "DwellTime";

  const getCvappFielkdForKNOWI = (appname) => {
    if (appname === DWELLTIME_APP) {
      return "fields." + DWELLTIME_APP + ".max";
    }
    return "fields." + appname + ".count";
  };

  async function fetch() {
    var cvApp = cVappList?.filter((m) => {
      return m.id == content.appName;
    })[0];
    if (cvApp) {
      var fieldValue = cvApp?.image == DWELLTIME_APP ? getCvappFielkdForKNOWI(DWELLTIME_APP) : getCvappFielkdForKNOWI(cvApp?.image);
      let stats;
      stats = await getWidgetStatistics(activeSession, fieldValue, content.location, selectedTimerData, locationDeviceMapping);
      setData({
        netValue: !isEmpty(stats) ? (cvApp?.image != DWELLTIME_APP ? stats[stats.length - 1] - stats[0] : Math.max(...stats) - Math.min(...stats)) : 0,
        value: !isEmpty(stats) ? (cvApp?.image != DWELLTIME_APP ? stats[stats.length - 1] : Math.max(...stats)) : 0,
        sparklineData: stats
      });
    } else {
      setData({ netValue: 0, value: 0, sparklineData: [] });
    }
  }

    // Format the selectedTimerValue to Last 10 min
    const formattedTimerValue = formatTimerValue(selectedTimerData);

    useEffect(() => {
      if(cVappList?.length > 0){
      fetch();
      }
    }, [selectedTimerData, cVappList]);

    useInterval(async () => {
      fetch();
    }, INTERVAL_TIMER);
    
    const navigateTostatistics = (e) =>{
      const appName = getcvAppDispName(cVappList, e.appName);
      var appn = WidgetListFrmStatReducer.find(f => {
            return f.name.includes(appName.replace(" ", "").toLowerCase()) && f.name.includes("loc") && f.name.includes("_1_")
      });
      if (!appn) {
        console.warn(`Navigation failed: Unable to find statistics for app ${appName}`);
        return;
      }
      const appTitle = appn?.name?.includes("Dwell Time") ? "Dwell Time" : appName;

      const roiWithCvapp = roiList.filter(f => {return f.cvapps != undefined && f.cvapps[0].resources.displayName == appTitle && f.deployments != undefined && f.deployments[0].status == "deployed"});
      var sitName = sitesTagList.sites.find(s => {return s.name == locationHierarcy.split("/")[0]});
      sitName["virtualId"] = getDeviceVirtualIdFromTagId(sitName.id, roiWithCvapp, appTitle);
      var florName = sitesTagList.floors.filter(s => {return s.name == locationHierarcy.split("/")[1]});
      if(locationHierarcy.indexOf("/") > -1 && locationHierarcy.split("/").length >= 0){
       florName[0]["virtualId"] = getDeviceVirtualIdFromTagId(florName[0].id, roiWithCvapp, appTitle);
      }
      var araName = [];
      if(locationHierarcy.split("/").length >= 3){
        florName = [];
        araName = sitesTagList.areas.filter(s => {return s.name == locationHierarcy.split("/")[2]});
        araName[0]["virtualId"] = getDeviceVirtualIdFromTagId(araName[0].id, roiWithCvapp, appTitle);
      }
      
      var subaraName = [];
      if(locationHierarcy.split("/").length >= 4){
        florName = [];
        araName = [];
        subaraName = sitesTagList.subareas.filter(s => {return s.name == locationHierarcy.split("/")[3]});
        subaraName[0]["virtualId"] = getDeviceVirtualIdFromTagId(subaraName[0].id, roiWithCvapp, appTitle);
      }

      navigate(`/statistics?appName=${setpathParam(appTitle)}`, {state:{ 
        appName: appTitle,
        appNameId: appTitle,
        siteName: sitName.name,
        siteId: sitName.id,
        site: [sitName],
        floor: florName.length > 0 ? florName.filter(f => {return f.id == content.location}) : [],
        area: araName.length > 0 ? araName.filter(f => {return f.id == content.location}) : [],
        subarea: subaraName.length > 0 ? subaraName.filter(f => {return f.id == content.location}) : [],
        //allFloors: undefined,
       //allAreas: [],//state?.allAreas,
        //allSubAreas: [], //state?.allSubAreas,
      }})
    }

  const tooltipContent = (
    <div style={{ width: "auto", padding: "5px", color: "black", fontSize: "12px" }}>
      <Body size="small" viewport="desktop">
        {locationHierarcy}
      </Body>
    </div>
  );
 return (
    <>
    {editMode && 
        <>
            <WidgetEdit onDragStart={onDragStart} draggable style={{cursor: "all-scroll" }}>
                <Icon
                    name="menu"
                    color="#000000"
                    size="small"
                    />
            </WidgetEdit>
            <div style={{position: "absolute", zIndex: 1, right:"0px"}} onClick={() => clearClicked(id)}>
                <Icon
                    name="close-alternate"
                    color="#6F7171"
                    size="large"
                    />
            </div>
        </>}
        <WidgetWrapStyle>
                  <div className="appInfoWrap" style={{display: "flex", justifyContent: "space-between"}} data-testid="dashboard_widgetAppNavToStatistics" onClick={() => navigateTostatistics(content)}>
                    <div className="appTitleName" 
                    style={{display: "flex", background: "var(--vds-color-palette-blue-94, #E3F2FD)", borderRadius: "4px", padding: "3px", marginBottom: "3px"}}>
                      <div style={{ lineHeight: "1px", marginRight: "6px" }} >
                        <StyledIcon
                          name={getIcon(getcvAppName(cVappList, content.appName))}
                          size="medium"
                          color="#000000"
                        />
                      </div>
                      <Tooltip
                        title={getcvAppDisplayName(cVappList, content.appName)}
                        placement="top"
                        arrow
                      >
                        <div className="appName truncateText">
                          {getcvAppDisplayName(cVappList, content.appName)}
                        </div>
                      </Tooltip>
                    </div>
                    <div className="appLocationRow" style={{ display: "flex", marginTop: "4px" }}>
                      <div style={{ margin: "-2px 7px 0 0" }}>
                        {" "}
                        <LocationAlt size="small" />{" "}
                      </div>
                      {content.location && (
                        <Tooltip
                          placement="top"
                          arrow
                          title={tooltipContent}
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "white",
                                border: "1px solid black",
                                "& .MuiTooltip-arrow": {
                                  backgroundColor: "white",
                                },
                              },
                            },
                          }}
                        >
                          <div className="locationTextStyle truncateText"> {locationHierarcy?.split("/")?.[locationHierarcy?.split("/")?.length -1 ]} </div>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div className="statisticsDataWraps" style={{display: "flex", justifyContent: "space-between"}}>
                   {roiListWithCvappsLoadingStatus === ROI_LIST_WITH_CVAPPS_LOADING_STATUS.Loaded && cVappList?.length > 0 ? <> <div className="statisticData">
                      <div className="lastUpdatedText">{formattedTimerValue !== "" ? formattedTimerValue + ".": "Last 10 min."}</div>
                      <div style={{ display: "flex", marginTop: "8px" }}>
                        {getcvAppName(cVappList, content.appName).toLowerCase() === "dwell time" ? (
                          <div style={{ marginRight: "8px" }}>
                          <div className="dynamicData2">
                            {convertToTimeWithValues(Math.round(data?.value))}
                          </div>
                          <div className="dynamicDataInfo">max. time</div>
                        </div>
                        ) : (
                          <div style={{ marginRight: "16px" }}>
                            <div className="dynamicData">
                              {data?.value}
                            </div>
                            <div className="dynamicDataInfo"> total </div>
                          </div>
                        )}
                        <div
                          style={{
                            borderLeft: "2px solid #D8DADA",
                            paddingRight: "8px",
                            paddingTop:"6px"
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            {trendIconSelect(data?.netValue)}
                            {data?.netValue !== 0 && (
                              <span className="netValueStyles">
                                {getcvAppName(cVappList, content.appName).toLowerCase() === "dwell time" ? convertToTimeWithNetValues(Math.round(Math.abs(data?.netValue))) : Math.round(Math.abs(data?.netValue))}
                              </span>
                            )}
                          </div>
                          {/* {data?.netValue !== 0 &&
                            content.appName.toLowerCase() === "dwell time" && (
                              <div className="trendText"> hh:mm:ss </div>
                            )} */}
                        </div>
                      </div>
                    </div>
                    <SparklineContainer>
                      <Stack direction="row" sx={{ width: "auto" }}>
                        <Box sx={{ flexGrow: 1 }}>
                          <SparkLineChart
                            data={data?.sparklineData}
                            yAxis={{
                              max: Math.max(...data?.sparklineData) === 0 ? 50 : undefined
                            }}
                            height={40}
                            colors={["#0089EC"]}
                            showHighlight={true}
                            showTooltip={true}
                            valueFormatter = {(value) => getcvAppName(cVappList, content.appName).toLowerCase() === "dwell time" ? convertToTimeWithValues(Math.round(value)): value}
                          />
                        </Box>
                      </Stack>
                    </SparklineContainer>
                    </> :<><div className="lazySpinner"><Spinner className="spinnerSize"></Spinner></div><div className="loadingMessage">Loading widget data...</div></>}
                  </div>
                </WidgetWrapStyle>
    </>
 )
}

export default StatWidget;
